import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	placeholder: {
		id: `eoc.alert-list.common.select.plceholder`,
		defaultMessage: 'Search',
		description: 'The label of input that searchs inside team.',
	},
});

export default messages;
